var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',[_c('LabelledValue',{attrs:{"label":"Issue","value":_vm.page.issue.name}}),_c('LabelledValue',{attrs:{"label":"Slug","value":_vm.page.slug}}),_c('LabelledEditableValue',{attrs:{"label":"Notes","multi-line":true},on:{"blur":_vm.save},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }